import { ArrowRight } from "@/components/Icon"
import React, { FC } from "react"
import { useTranslation } from "react-i18next"
import Block from "@/components/Block"
import Container from "@/components/Container"
import Box from "@/components/Box"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import SimpleFadeTextAnimation from "@/components/SimpleFadeTextAnimation"
import RevealTextAnimation from "@/components/RevealTextAnimation"
import styled from "@emotion/styled"
import Link from "@/components/Link"
import Button from "@/components/Button"
import { TransactionData } from "./data"

//TODO:logic need to improve, locale key needs renaming
const contentList = [
  "securityStorage",
  "fundAccess",
  "transactions",
  "withdrawals",
  "reserve",
]

const ImageBackground = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  filter: brightness(50%);
  object-fit: cover;
`

const TransactionSection: FC<{
  transactionContent: TransactionData
}> = ({ transactionContent }) => {
  const { t } = useTranslation("security")

  return (
    <Block bg="backgroundSecurityGrey" position="relative" overflow="hidden">
      <ImageBackground>
        <img
          src={`${process.env.ASSETS_BASE_URL}/security-page/transaction-section/server.webp`}
          alt="Server"
          height="100%"
          loading="lazy"
        />
      </ImageBackground>
      <Container style={{ position: "relative", zIndex: 2 }}>
        <SimpleFadeTextAnimation>
          <Box width={["100%", 448, 782]}>
            <Typography variant="h4" color="primaryBrightBlue" mb={[2, 1, 2]}>
              {t("section_two.eyebrow")}
            </Typography>
          </Box>
        </SimpleFadeTextAnimation>

        <Box width={["100%", 448, 782]}>
          <Typography variant="h2" mb={[12, 8, 16]}>
            <RevealTextAnimation
              text={t("section_two.h2_new") as string}
            ></RevealTextAnimation>
          </Typography>
        </Box>
        {transactionContent.map((content, index) => {
          const Icon = content.IconComponent
          return (
            <SimpleFadeTextAnimation key={content.name}>
              <Flex
                flexDirection={["column", "row"]}
                alignItems={["center", "flex-start"]}
                justifyContent={"space-between"}
                mt={content.name === "1:1 reserve" ? [4, 5, 8] : [0]}
              >
                <Box order={[2, 1]}>
                  <Box width={["100%", 448, 804]} mb={[4, 2, 3]}>
                    <Typography variant="h5" color="secondaryLightGrey">
                      {t(content.titleKey)}
                    </Typography>
                  </Box>
                  <Box
                    width={["100%", 448, 804]}
                    mb={index === 4 ? [1, 0.5, 1] : [8, 4, 8]}
                  >
                    <Typography
                      variant="bodyCopy"
                      color="#A0A9BE"
                      dangerouslySetInnerHTML={{
                        __html: t(content.descriptionKey),
                      }}
                    />
                  </Box>
                  {content.isShowCTA && (
                    <Link href={"/proof-of-reserves"}>
                      <Button
                        variant="plain"
                        display="flex"
                        alignItems="center"
                        height={["50px", "42px", "50px"]}
                        color={"white"}
                      >
                        <Typography
                          variant="p"
                          fontSize={[14]}
                          fontWeight={[600]}
                          lineHeight={["145%"]}
                          letterSpacing={["0.01em"]}
                          whiteSpace={"nowrap"}
                        >
                          {t(`section_two.contents_4_cta`)}
                        </Typography>
                        <ArrowRight
                          fontSize="12px"
                          pl={"12px"}
                          pt={["1px", null, "3px"]}
                        />
                      </Button>
                    </Link>
                  )}
                </Box>
                <Flex
                  width={[156, 136, 156]}
                  height={[116, 129, 148]}
                  order={[1, 2]}
                  ml="auto"
                  mr={[-4, 0]}
                  mb={[5, 0]}
                  flexDirection={"column"}
                  borderRadius={12}
                  border={"1px solid rgba(255, 255, 255, 0.4)"}
                  py={[2, "12px", 2]}
                  pl={[2, "12px", 2]}
                >
                  <Icon fontSize={[40, 56, 64]} mb={"auto"} />
                  <Typography
                    ml={[0, "5px", 1]}
                    color={"#FFF"}
                    variant="p"
                    fontSize={[16, 17, 18]}
                    fontWeight={[500, 600]}
                    lineHeight={["135%", "normal"]}
                    wordBreak={"break-all"}
                    mr={[1, 0]}
                  >
                    {t(content.iconTitleKey)}
                  </Typography>
                </Flex>
              </Flex>
            </SimpleFadeTextAnimation>
          )
        })}
      </Container>
    </Block>
  )
}

export default TransactionSection
